import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.49561 11.2537L2.99623 9.75307L4.49686 11.2537"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5044 12.7503L21.0037 14.2509L19.5031 12.7503"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.67493 6.78783C7.15151 3.27456 11.7686 2.00606 15.6926 3.76085C19.6165 5.51565 21.7492 9.80271 20.7816 13.9908"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3211 17.2122C16.8445 20.7254 12.2274 21.9939 8.30343 20.2391C4.37951 18.4843 2.24684 14.1973 3.21436 10.0092"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0017 16.0017C15.8854 15.709 15.7049 15.4461 15.4735 15.2323V15.2323C15.0836 14.87 14.5711 14.6684 14.0389 14.6681H9.96217C9.42961 14.6685 8.91685 14.87 8.52657 15.2323V15.2323C8.29572 15.4465 8.1153 15.7093 7.99835 16.0017"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx={12}
      cy={10.2493}
      r={2.25094}
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
